import React from "react";
import Textfield from "../Textfield/Textfield";
import PrimaryButton from "../Buttons/PrimaryButton";
import { DEFAULT_SUBMIT_BUTTON_LABEL, SLIDER_POSITION_FALLBACK } from "../../constants/constants";

import styles from "./SearchCard.module.scss";

const SearchCard = ({
  tabs,
  activeCard,
  setActiveCard,
  config,
  values,
  handleChange,
  errors,
  touched,
  handleBlur,
  isLoading,
  submitButtonLabel = DEFAULT_SUBMIT_BUTTON_LABEL,
  showTabHeader = true,
}) => {
  if (!tabs) return null;
  if (!config) return null;
  if (!values) return null;

  const getSliderPosition = () => {
    const index = tabs.findIndex((tab) => tab.key === activeCard);
    if (index === -1) return SLIDER_POSITION_FALLBACK;
    return index;
  };

  const currentTab = tabs.find((tab) => tab.key === activeCard);
  const isActiveFieldEnabled = Boolean(activeCard && config[activeCard]);
  const fieldValue = activeCard ? values[activeCard] : "";
  const fieldError = errors && activeCard ? errors[activeCard] : undefined;
  const isFieldTouched = Boolean(touched && activeCard && touched[activeCard]);
  const hasFieldValue = Boolean(fieldValue && fieldValue.trim() !== "");
  const shouldShowFieldError = Boolean(
    fieldError && (isFieldTouched || hasFieldValue),
  );
  const fieldLabel = currentTab ? currentTab.placeholder : "";

  const sliderClassName = [
    styles.slider,
    styles[`sliderPosition${getSliderPosition()}`],
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={styles.wrapper}>
      {showTabHeader && (
        <div className={styles.tabHeader}>
          {tabs.map((tab) => {
            const isEnabled = Boolean(config[tab.key]);

            return (
              <div
                key={tab.key}
                className={`${styles.tabItem}
          ${activeCard === tab.key ? styles.active : ""}
          ${!isEnabled ? styles.disabled : ""}`}
                onClick={() => {
                  if (!isEnabled) return;
                  if (!setActiveCard) return;
                  setActiveCard(tab.key);
                }}
              >
                {tab.label}
              </div>
            );
          })}

          {activeCard && <div className={sliderClassName} />}
        </div>
      )}

      <div className={styles.content}>
        {isActiveFieldEnabled && (
          <>
            <Textfield
              name={activeCard}
              label={fieldLabel}
              value={fieldValue}
              handleOnChange={handleChange}
              onBlur={handleBlur}
              error={shouldShowFieldError}
              helperText={shouldShowFieldError ? fieldError : undefined}
            />

            <div className={styles.actionWrapper}>
              <PrimaryButton type="submit" isLoading={isLoading} fullWidth>
                {submitButtonLabel}
              </PrimaryButton>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SearchCard;
